import { parseSearchParams } from 'common-ui/utils/parseSearchParams'

export const getLocationParams = () => {
  const search = document.location.href.split('?').pop()
  if (!search) return {}
  return parseSearchParams(search)
}
